import { Component, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

import { ChangePasswordService } from '../change-password/change-password.service';
import { AutenticacionService } from '../../seguridad/autenticacion.service';
import { SettingService } from '../../nucleo/configuracion/setting.service';
import { IResponseData } from '../../nucleo/interface/dto/IResponseData';
import { Constante } from '../../nucleo/constante/constante';
import { IUsuario } from '../../nucleo/interface/dto/IUsuario';
import { ICombo } from '../../nucleo/interface/form/ICombo';
import { HttpResponse } from '@angular/common/http';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})

export class LoginComponent implements OnInit {
  public usuario: IUsuario;
  public perfil: string;
  public mensaje: string;
  public combo: Array<ICombo>;
  public flagFormLogin: boolean;
  public session: HttpResponse<IResponseData>;

  constructor(private router: Router,
              private loginService: AutenticacionService,
              public settingService: SettingService,
              private changePwdService: ChangePasswordService) { 
    this.usuario = {
      usrLogin: '',
      password: ''
    }
    this.combo = [];
    this.flagFormLogin = true;
    this.perfil = '';
  }

  ngOnInit() {
  }

  login(formulario: NgForm){ 
    this.loginService.login(this.usuario).subscribe( response => {
      if(response.body.codigo === Constante.RESPUESTA_OK) {
        const perfiles = response.body.entidad.perfilAuths as [];
        if(perfiles.length > 1){
          this.combo = perfiles;
          this.flagFormLogin = false;
          this.session = response;
        } else {
          this.mensaje =this.settingService.getMensaje('C0002');
          this.cargarSessionStorage(response);
        }
      } else {
        this.mensaje = response.body.mensaje;
      }
    }, (error: Error) => {
      console.log(error.message);
      this.mensaje = this.settingService.getMensaje('C0062');
    })
  }

  loginPerfil(formulario: NgForm) {
    const nivel = formulario.form.value.perfil;
    const perfil = this.combo.filter( obj => obj.nivel === nivel)[0].descripcion;
    this.cargarSessionStorage2(perfil, nivel);
    this.router.navigate(['/home']);
  }

  private cargarSessionStorage(response: HttpResponse<IResponseData>) {
    const usuario = response.body.entidad;
    const perfil = response.body.entidad.perfilAuths as [any];

    sessionStorage.setItem('usuario', usuario.usrLogin);
    sessionStorage.setItem('codigo_area', usuario.usrCodigoArea);
    sessionStorage.setItem('nombre_completo', usuario.usrDescrip);
    sessionStorage.setItem('fecha_registro', usuario.usrFechReg);
    sessionStorage.setItem('ubicacion',usuario.usrUbicacion);
    sessionStorage.setItem('cargo',usuario.usrCargo);
    sessionStorage.setItem('perfil', perfil[0].descripcion);
    sessionStorage.setItem('nivel', perfil[0].nivel);

    sessionStorage.setItem('token', response.headers.get('authorization'));

    this.router.navigate(['/home']);
  }

  private cargarSessionStorage2(perfil: string, nivel: string) {
    const usuario = this.session.body.entidad;

    sessionStorage.setItem('usuario', usuario.usrLogin);
    sessionStorage.setItem('codigo_area', usuario.usrCodigoArea);
    sessionStorage.setItem('nombre_completo', usuario.usrDescrip);
    sessionStorage.setItem('fecha_registro', usuario.usrFechReg);

    sessionStorage.setItem('perfil', perfil);
    sessionStorage.setItem('nivel', nivel);

    sessionStorage.setItem('token', this.session.headers.get('authorization'));
  }
  
}
